import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "py-2 px-6" }
const _hoisted_2 = { class: "text-lg py-2 font-medium" }
const _hoisted_3 = {
  key: 0,
  class: "py-2"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-800" }, "Der er ingen mobiliseringer i denne uge.", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "py-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "boarding_days",
  class: "block text-sm font-medium leading-6 text-secondary"
}, " Kost ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block" }, "Angiv en gyldig værdi", -1)
const _hoisted_9 = {
  key: 2,
  class: "py-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "lodging_days",
  class: "block text-sm font-medium leading-6 text-secondary"
}, " Logi ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block" }, "Angiv en gyldig værdi", -1)
const _hoisted_12 = {
  key: 3,
  class: "py-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "connecting_hours",
  class: "block text-sm font-medium leading-6 text-secondary"
}, " Tilsluttende timer ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block" }, "Angiv en gyldig værdi", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, " Uge " + _toDisplayString(_ctx.currentWeek), 1),
    (_ctx.state === 'FREE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.state !== 'FREE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "distance_registered",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.boardingDays) = $event)),
              name: "boarding_days",
              type: "number",
              inputmode: "numeric",
              placeholder: "Antal hele døgn",
              class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 512), [
              [_vModelText, _ctx.boardingDays]
            ]),
            _hoisted_8
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state !== 'FREE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "distance_registered",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lodgingDays) = $event)),
              name: "lodging_days",
              type: "number",
              inputmode: "numeric",
              placeholder: "Antal hele døgn",
              class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 512), [
              [_vModelText, _ctx.lodgingDays]
            ]),
            _hoisted_11
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state !== 'FREE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "distance_registered",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.connectingHours) = $event)),
              name: "connecting_hourss",
              type: "number",
              step: "0.1",
              inputmode: "numeric",
              placeholder: "Antal timer",
              class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 512), [
              [_vModelText, _ctx.connectingHours]
            ]),
            _hoisted_14
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}